var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboard-analytics"}},[_c('b-row',[(_vm.isReportAllowed)?_c('b-col',{attrs:{"lg":"5"}},[_c('RevenueExpenseCard')],1):_vm._e(),_c('b-col',{attrs:{"lg":"7"}},[_c('HomeProperties')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }